import React from 'react';
import { OfficePickupRule } from './remainsApi';

/**
 * The one line under a pickup date field, and the reason box for going earlier.
 * The field's own `min` greys out the earlier days, so "Use an earlier date" is
 * what lifts it; typing an earlier date by hand asks for the reason just the same.
 */
export const PickupDayRuleNote: React.FC<{
  rule: OfficePickupRule;
  tooEarly: boolean;
  allowEarlier: boolean;
  onAllowEarlier: () => void;
  reason: string;
  onReasonChange: (reason: string) => void;
}> = ({ rule, tooEarly, allowEarlier, onAllowEarlier, reason, onReasonChange }) => {
  if (!rule.reason) return null;
  return (
    <div className="flex flex-col gap-1.5 w-full" data-testid="pickup-day-rule">
      <div className="text-[12px] leading-4 text-foreground">
        {rule.reason}{' '}
        {!allowEarlier && !tooEarly && (
          <button
            type="button"
            onClick={onAllowEarlier}
            className="text-muted-foreground underline underline-offset-2 hover:text-foreground"
          >
            Use an earlier date
          </button>
        )}
      </div>
      {(allowEarlier || tooEarly) && (
        <input
          type="text"
          aria-label="Reason for the earlier date"
          placeholder="Reason for the earlier date"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          className="h-9 w-full rounded-lg border border-input bg-background px-3 text-[13px] text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring/40"
        />
      )}
    </div>
  );
};
